import { Block } from 'ia-react-core';
import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getOnpremHostname } from 'omni-package-react-core';
import {
  StyledMainDivForm, StyledImageSuccess, StyledConfirmationLine1,
  StyledConfirmationLine2, StyledConfirmButton,
} from './ChangePasswordConfirmPage.styles';

export interface ChangePasswordConfirmPageProps {
  title: string;
  mobileDeviceMode: Boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ChangePasswordConfirmPage: FC<ChangePasswordConfirmPageProps> = ({ title, mobileDeviceMode }) => {
  const { t } = useTranslation('ChangePasswordConfirmPage');
  const connectButton = useRef(null);
  const onPremHostName = getOnpremHostname();

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    connectButton.current.focus();
  }, []);

  return (
    <>
      <Helmet><title>{title}</title></Helmet>
      <div className="app-body">
        <StyledMainDivForm className="mainDivForm">
          <Block white>
            <StyledImageSuccess className="imageSuccess" alt={t('notFound')} />
            <StyledConfirmationLine1 className="confirmationLine1">{t('YourPassword')}</StyledConfirmationLine1>
            <StyledConfirmationLine2 className="confirmationLine2">{t('CanBeUsed')}</StyledConfirmationLine2>
            <StyledConfirmButton ref={connectButton} className="button-confirm" autoFocus onClick={() => { window.location.href = `${onPremHostName}/eemwpnp1/public/gologin/`; }}>{t('Connect')}</StyledConfirmButton>
          </Block>
        </StyledMainDivForm>
      </div>
    </>
  );
};

export default ChangePasswordConfirmPage;
